import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  cardHeader: () => ({
    minHeight: 60,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    lineHeight: 1,
    backgroundColor: "#4187B6 !important",
    color: "white !important",
    wordWrap: "break-word",
  }),
  assignedContent: {
    color: "rgba(0, 0, 0, 0.54)",
  },
  cardContent: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    wordWrap: "break-word",
  },
  cardActions: {
    borderTop: "1px solid #e4eaec",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  resourceFrame: {
    marginTop: theme.spacing(2),
  },
}));
